@if (layout() === 'default') {
  <div
    class="relative flex flex-col overflow-x-hidden w-screen h-[100dvh] overflow-hidden"
  >
    <app-header class="safe-top" [menus]="menus" />

    <!-- router outlet 경로 -->
    <div
      #layoutRef
      (scroll)="onLayoutScroll()"
      class="flex flex-col overflow-y-auto bg-white size-full rounded-t-2xl basis-full grow-0"
    >
      <app-guard />
      <div class="flex h-full items-end w-full">
        <app-footer class="hidden xl:block mt-[5rem] w-full" />
      </div>
    </div>

    @if (!layoutStore.isShowPageModal$()) {
      <div class="w-full z-10 block xl:hidden">
        <app-bottom-sheet [menus]="menus" />
      </div>
    }
  </div>
} @else {
  <div
    class="relative min-h-screen flex flex-col overflow-x-hidden w-screen h-full overflow-hidden"
  >
    <div
      #layoutRef
      (scroll)="onLayoutScroll()"
      class="container flex flex-col overflow-y-auto bg-white size-full rounded-t-2xl basis-full grow-0"
    >
      <router-outlet />
    </div>
  </div>
}
